import {
  Component,
  input,
  Input,
  model,
  output,
  signal,
  ViewChild,
} from '@angular/core';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'c-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrl: './autocomplete.component.css',
  standalone: false,
})
export class AutocompleteComponent {
  /** Etiqueta del input */
  @Input() etiqueta = 'Inserte etiqueta';
  /** Placeholder del input */
  @Input() placeholder = 'Inserte placeholder';
  /** Define si agrega las opciones nuevas del input */
  @Input() agregarItems = false;
  /** La propiedad, si existe, de los objetos */
  @Input() propiedad!: string;
  /** Define si es multiple o no */
  @Input() multiple!: boolean;
  /** Opción seleccionada */
  option = model<any>();
  /** Las opciones del filtro */
  options = input<any[]>([]);
  /** Las sugerencias del autocomplete */
  sugerencias = signal<any[]>([]);
  /** Muestra o no las animaciones del componente */
  show = false;

  completeMethod = output<string>();
  customSearch = input<boolean>(false);

  /** El filtro de las sugerencias */
  buscar(ev: AutoCompleteCompleteEvent) {
    this.completeMethod.emit(ev.query);

    if (this.agregarItems) {
      const op = this.options().filter((d) =>
        this.propiedad ? d[this.propiedad] : d,
      );
      this.sugerencias.set(
        op.filter((data) =>
          this.propiedad
            ? (data[this.propiedad] as string)
                .toLowerCase()
                .includes(ev.query.toLowerCase())
            : (data as string).toLowerCase().includes(ev.query.toLowerCase()),
        ),
      );
      if (
        !this.sugerencias().some((s) =>
          this.propiedad
            ? s[this.propiedad].toLowerCase() == ev.query.toLowerCase()
            : s.toLowerCase() == ev.query.toLowerCase(),
        )
      ) {
        this.sugerencias().unshift(
          this.propiedad ? { [this.propiedad]: ev.query } : ev.query,
        );
      }
    } else {
      const op = this.options().filter((d) =>
        this.propiedad ? d[this.propiedad] : d,
      );
      this.sugerencias.set(
        op.filter((data) =>
          this.propiedad
            ? (data[this.propiedad] as string)
                .toLowerCase()
                .includes(ev.query.toLowerCase())
            : (data as string).toLowerCase().includes(ev.query.toLowerCase()),
        ),
      );
    }
  }

  /** Toma el valor del input. Solo para la lógica */
  valorInput!: string;
  /** Obtenemos la referencia del autocomplete */
  @ViewChild('autocomplete') private readonly autocomplete!: AutoComplete;
  ngAfterViewInit(): void {
    //* Ponemos en el input del autocomplete un escuchador de eventos
    this.autocomplete.inputEL?.nativeElement.addEventListener('input', () => {
      //* Solo para obtener el valor del input
      this.valorInput = this.autocomplete.inputEL?.nativeElement.value;
    });
  }
  /** Limpiamos el valor del input */
  limpiarInput() {
    this.valorInput = '';
  }
}
